import { getState } from 'lib/store'

/**
 * Get access token
 */
export const getToken = (): string | null => getState().auth.token

/**
 * Get username
 */
export const getUsername = (): string | null => getState().auth.username

/**
 * Check if user is logged in (has a valid token)
 */
export const isUserLoggedIn = (): boolean => {
  const token = getToken()
  return token !== null && token.length > 0
}

/**
 * Check if login is in progress
 */
export const isLoggingIn = (): boolean => getState().auth.isLoggingIn

/**
 * Get login error message
 */
export const getLoginError = (): string | null => getState().auth.loginError
